/**
 * Creates new HTML element
 * @param {String} tagName
 * @param {Object} attributes
 * @param {String} innerText
 */
export const createElement = (tagName, attributes, innerText = null) => {
    const el = document.createElement(tagName);

    setAttributes(el, attributes);

    if (innerText) el.innerText = innerText;

    return el;
};

/**
 * Sets element attributes
 * @param {HTMLElement} el
 * @param {Object} attributes
 */
export const setAttributes = (el, attributes) => {
    for (const [key, value] of Object.entries(attributes)) {
        el.setAttribute(key, value);
    }
};

/**
 * Removes child elements
 * @param {HTMLElement} el
 */
export const removeChildren = (el) => {
    if (!el.firstChild) return;

    while (el.firstChild) el.removeChild(el.lastChild);
};

/**
 * Gets the "Y" position of an element from the top of the page
 * @param {HTMLElement} element
 */
export const getAbsoluteElementOffsetTop = (element) => {
    let offsetTop = element.offsetTop;
    let elementParent = element.offsetParent;

    while (elementParent) {
        offsetTop += elementParent.offsetTop;
        elementParent = elementParent.offsetParent;
    }

    return offsetTop;
};

/**
 * Calculates and assings (100vh - navigation height) to an element
 * @param {HTMLElement} element
 */
export const calculateFullViewportHeightWithOffset = (element) => {
    const nav = document.querySelector(".js-module-nav");

    if (!nav) return;

    element.style.height = `calc(100vh - ${nav.offsetHeight}px`;
};

/**
 * Traverse a DOM structure in a specified direction and get an element by a className, if not found return false
 * @param {HTMLElement} element
 * @param {String} direction - "parentElement", "nextElementSibling", ....
 * @param {String} className - classname we are searching for
 */
export const findRelatedElementByClassName = (element, direction, className) => {
    let nextElement = element[direction];

    if (element.classList.contains(className)) return element;

    while (nextElement) {
        if (nextElement.classList.contains(className)) {
            return nextElement;
        }

        nextElement = nextElement[direction];
    }

    return false;
};

/**
 * Traverse a DOM structure in a specified direction and get an element by an element, if not found return false
 * @param {HTMLElement} element
 * @param {String} direction - "parentElement", "nextElementSibling", ....
 * @param {String} wantedElement - element we are searching for
 */
export const findRelatedElementByElement = (element, direction, wantedElement) => {
    let nextElement = element[direction];

    if (element === wantedElement) return element;

    while (nextElement) {
        if (nextElement === wantedElement) {
            return nextElement;
        }

        nextElement = nextElement[direction];
    }

    return false;
};

/**
 * Highlights a subtring
 * @param {String} str - the original string
 * @param {String} subStr - substring to highlight
 * @param {String} className - css class to add to the highlighted element
 */

export const highlightSubtring = (str, subStr, className) =>
    str.replace(new RegExp(subStr, "ig"), `<span class='${className}'>$&</span>`);
